var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinishSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 87.4166C55.3059 87.4166 42.5833 74.6941 42.5833 59C42.5833 43.3059 55.3059 30.5833 71 30.5833C86.6941 30.5833 99.4167 43.3059 99.4167 59C99.4167 74.6941 86.6941 87.4166 71 87.4166ZM71 82.25C83.8406 82.25 94.25 71.8406 94.25 59C94.25 46.1594 83.8406 35.75 71 35.75C58.1594 35.75 47.75 46.1594 47.75 59C47.75 71.8406 58.1594 82.25 71 82.25ZM80.921 50.8375C80.1399 50.0565 78.8736 50.0565 78.0925 50.8375L67.2477 61.6824C66.4666 62.4634 65.2003 62.4634 64.4192 61.6824L61.3244 58.5875C60.5433 57.8065 59.277 57.8065 58.4959 58.5875L57.671 59.4125C56.8899 60.1935 56.8899 61.4599 57.671 62.2409L64.4192 68.9892C65.2003 69.7702 66.4666 69.7702 67.2477 68.9892L81.7459 54.4909C82.527 53.7099 82.527 52.4435 81.7459 51.6625L80.921 50.8375Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.583328,
    y: 0.583313,
    width: 124.833,
    height: 124.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313725 0 0 0 0 0.0980392 0 0 0 0 0.227451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 79.525,
    y1: 41.95,
    x2: 66.7375,
    y2: 87.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445315,
    stopColor: "#27AE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16522F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishSuccess);
export default __webpack_public_path__ + "static/media/finish-success.f351862007da2256b71c34abb826e0cd.svg";
export { ForwardRef as ReactComponent };